import React, {useEffect, useMemo, useRef, useState} from 'react'
import styles from './EventGroupListingPage.module.css';
import {useParams} from "react-router";
import {
    AppBar,
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel, ListItemText, MenuItem,
    OutlinedInput,
    Select, SelectChangeEvent,
    Stack
} from "@mui/material";
import axios from "axios";
import SelectInput from '../../components/common/inputs/SelectInput/SelectInput'
import HookForm from "../../components/common/HookForm";
import {useForm} from "react-hook-form";
import {useAutoEvt} from "../../queries/useAutoEvt";
import {Button} from "@material-ui/core";
import download from 'downloadjs';
import LoadingBackdrop from "../../components/common/LoadingBackdrop";

interface Params {
  eventid: string
}

interface FormData {
    ticketid: number
    sizeid: number
}

const EventGroupListingPage = () => {
    const { eventid } = useParams<Params>()
    const { handleSubmit } = useForm()
    const [includeUnregisteredGuest, setIncludeUnregisteredGuest] = useState(true);
    const [oneGroupPerPage, setOneGroupPerPage] = useState(true);
    const [userdefinedSelection, setUserdefinedSelection] = React.useState<string[]>([]);
    const formMethods = useForm<FormData>()
    const [loading, setLoading] = React.useState(false)
    const { setValue, watch, getValues, setError, clearErrors, setFocus, reset } = formMethods

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    }

    console.log(eventid)
    useAutoEvt(eventid)

    const [groupData, setGroupData] = React.useState({selectedticketid: null, selectedsizeid: null, sizelist: [], ticketlist: [], userdefinedlist: [], status: '', message: ''})

    const getGroupListing = async () => {
        var body = {'eventid': eventid}
        const { data } = await axios.post('/evtgrouplisting', body)
        const parsedData = JSON.parse(data.jsonString)
        console.log(parsedData)

        reset({
            ticketid: parsedData.selectedticketid,
            sizeid: parsedData.selectedsizeid
        })

        setUserdefinedSelection(parsedData?.userdefinedlist?.map(item => {
            return item.userdefinedname
        }))
        setGroupData(parsedData)
    }



    useEffect(() => {
        getGroupListing()
    }, [])

    const userdefinedlist = groupData && groupData.userdefinedlist ? groupData.userdefinedlist : []
    const userDefinedOptions = useMemo(
        () => userdefinedlist.map((ud) => {
            return { value: ud.userdefinedid, label: ud.userdefinedname }
        }),
        [userdefinedlist]
    )

    const ticketTypeList = groupData && groupData.ticketlist ? groupData.ticketlist : []
    const ticketTypeOptions = useMemo(
        () => ticketTypeList.map((ticketType) => {
            return { value: ticketType.ticketid, label: ticketType.ticketname }
        }),
        [ticketTypeList]
    )
    const onSubmit = async (data: FormData) => {}
    const onSubmitExcel = async (data: FormData) => {
        setLoading(true)
        const values = getValues()

        var udToSave = []
        userdefinedlist?.forEach(tag => {
            if (userdefinedSelection.find((item) => item === tag.userdefinedname)) {
                udToSave.push(tag.userdefinedid)
            }
        })
        const commaSeparatedString = udToSave.join(',');

        const body = {
            eventid: Number(eventid),
            type: 'exportalltoexcel',
            includeunregisteredguests: includeUnregisteredGuest,
            onegroupperpage: oneGroupPerPage,
            userdefinedid: commaSeparatedString,
            ...values
        }

        axios.post(`evtgrouplistingprocess`, body, {responseType: "blob"}).then(response => {
            var filename = 'grouplistingpage.xlsx';
            // var disposition = response.headers['content-disposition']
            var disposition = response.headers['content-disposition']
            var contentType = response.headers['content-type']
            if (disposition && disposition.indexOf('attachment') !== -1) {
                console.log(disposition);
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }

            if (response.data) {
                setLoading(false)
                download(response.data, filename, contentType);
            }
        })
    }

    const onSubmitPDF = async (data: FormData) => {
        setLoading(true)
        const values = getValues()

        var udToSave = []
        userdefinedlist?.forEach(tag => {
            if (userdefinedSelection.find((item) => item === tag.userdefinedname)) {
                udToSave.push(tag.userdefinedid)
            }
        })

        const commaSeparatedString = udToSave.join(',');

        const body = {
            eventid: Number(eventid),
            type: 'exportpdf',
            includeunregisteredguests: includeUnregisteredGuest,
            onegroupperpage: oneGroupPerPage,
            userdefinedid: commaSeparatedString,
            ...values
        }

        axios.post(`evtgrouplistingprocess`, body).then(response => {
            var filename = 'grouplistingpage.pdf';

            var disposition = response.headers['content-disposition']
            var contentType = response.headers['content-type']
            if (disposition && disposition.indexOf('attachment') !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }

            if (response.data) {
                setLoading(false)
                download(response.data, filename, contentType);
            }
        })
    }

    const handleUnregisteredGuests = (event) => {
        setIncludeUnregisteredGuest(event.target.checked);
    }

    const handleOneGroupPerPage = (event) => {
        setOneGroupPerPage(event.target.checked);
    }

    const handleUserDefinedChange = (event: SelectChangeEvent<typeof userdefinedSelection>) => {
        const {
            target: { value },
        } = event;

        var values = []
        if (typeof value === 'string') {
            values = [value]
        }
        else {
            value?.forEach(v => {
                if (v.length > 0) {
                    values.push(v)
                }
            })
        }

        setUserdefinedSelection(values)
    }

    return (
      <div className={styles.root}>
        <LoadingBackdrop open={loading} />
        <h1>Group Listing Report</h1>
          <HookForm
              methods={formMethods}
              onSubmit={onSubmit}
              className={styles.itemsForm}
              formProps={{ id: 'items-form' }}>
              <Grid container spacing={3}>
                  <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column' }}>
                      <SelectInput
                          name={'ticketid'}
                          label={'Ticket Type'}
                          options={ticketTypeOptions}
                          includeNone={false}
                      />
                  </Grid>
                  <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column' }}>
                  </Grid>
                  <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column' }}>
                      <FormControl style={{width: '100%'}}>
                          <InputLabel style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-begin'}}>Included User Defined Fields</InputLabel>
                          <Select
                              labelId="demo-multiple-checkbox-label"
                              id="demo-multiple-checkbox"
                              name="userdefinedid"
                              value={userdefinedSelection}
                              onChange={handleUserDefinedChange}
                              multiple
                              input={<OutlinedInput label="Included User Defined Fields" />}
                              // input={<OutlinedInput label="Enter a Ticket" />}
                              renderValue={(selected) => selected.join(', ')}
                              MenuProps={MenuProps}
                              style={{ width: '100%' }}>
                              {
                                  userdefinedlist?.map(item => (
                                      <MenuItem key={item.userdefinedid} value={item.userdefinedname}>
                                          <Checkbox color="primary" checked={userdefinedSelection.indexOf(item.userdefinedname) > -1} />
                                          <ListItemText primary={item.userdefinedname} />
                                      </MenuItem>
                                  ))
                              }
                          </Select>
                      </FormControl>
                  </Grid>
                  <Grid item xs={6} style={{ display: 'flex', flexDirection: 'column' }}>
                  </Grid>
                  <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column' }}>
                      <FormControlLabel
                          control={
                              <Checkbox
                                  checked={includeUnregisteredGuest}
                                  onChange={handleUnregisteredGuests}
                                  name="includeunregisteredguests"
                              />
                          }
                          label="Include Unregistered Guests"
                      />
                  </Grid>
                  <Grid item xs={12} style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column' }}>
                      <FormControlLabel
                          control={
                              <Checkbox
                                  checked={oneGroupPerPage}
                                  onChange={handleOneGroupPerPage}
                                  name="oneGroupPerPage"
                              />
                          }
                          label="One Group Per Page"
                      />
                  </Grid>
              </Grid>

              <Grid container spacing={0}>
                  <Grid item xs={2.5} style={{ display: 'flex', flexDirection: 'column' }}>
                      <Button onClick={handleSubmit(onSubmitExcel)} name="generateword" type="submit" color="primary" variant="contained" className={styles.button}>
                          Export To Excel
                      </Button>
                  </Grid>
                  {/*<Grid item xs={.5} style={{ marginBottom: '15px', display: 'flex', flexDirection: 'column' }}>*/}
                  {/*</Grid>*/}
                  {/*<Grid item xs={2.5} style={{ display: 'flex', flexDirection: 'column' }}>*/}
                  {/*    <Button onClick={handleSubmit(onSubmitPDF)} name="generatepdf" type="submit" color="primary" variant="contained" className={styles.button}>*/}
                  {/*        Generate PDF*/}
                  {/*    </Button>*/}
                  {/*</Grid>*/}
              </Grid>
          </HookForm>
      </div>
    )
}

export default EventGroupListingPage
